import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// css
import './Home.css';
import 'aos/dist/aos.css';

// Components
import AppBar from '../../components/AppBar';
import Footer from '../../components/Footer';
import FaqSection from '../Sections/FaqSection';
import AffiliateSection from '../Sections/AffiliateSection';
import PurchaseSection from '../Sections/PurchaseSection';
import ContSection from '../Sections/ContSection';
import EarnSection from '../Sections/EarnSection';
import DevSection from '../Sections/DevSection';
import PhoneSection from '../Sections/PhoneSection';
import HomeSection from '../Sections/HomeSection';

// Evaluated once per full page load (not on in-app navigation): logged-in users
// landing directly on "/" get sent to the dashboard instantly via the local
// isAuthenticated flag, without waiting for verify-token. Navigating to Home
// from inside the app afterwards works normally. The flag is only a UX hint -
// if it's stale, the dashboard's own auth check sends the user to /login.
const openedSiteAtHome = window.location.pathname === '/';
let autoRedirectDone = false;

function Home() {
  const navigate = useNavigate();

  const shouldAutoRedirect =
    openedSiteAtHome &&
    !autoRedirectDone &&
    localStorage.getItem('isAuthenticated') === 'true';

  useEffect(() => {
    autoRedirectDone = true;
    if (shouldAutoRedirect) {
      navigate('/wallets', { replace: true });
    }
  }, [shouldAutoRedirect, navigate]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const refId = urlParams.get('ref');
    if (refId) {
      const expiryDate = new Date();
      expiryDate.setTime(expiryDate.getTime() + (30 * 24 * 60 * 60 * 1000));
      document.cookie = `affiliate_ref=${refId}; expires=${expiryDate.toUTCString()}; path=/; SameSite=Lax`;
    }
  }, []);

  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.slice(1);
      const timer = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
      return () => clearTimeout(timer);
    }
  }, []);

  if (shouldAutoRedirect) {
    return null;
  }

  return (
    <div>
    <AppBar /> 

    <HomeSection />

    <PhoneSection />

    <DevSection />  

    <EarnSection />

    <ContSection />  

    <PurchaseSection />   

    <AffiliateSection />

    <FaqSection />

    <Footer />
    </div>
  );
}

export default Home;